import React from 'react';
import Popup from 'ol-ext/overlay/Popup';

import { MenuList } from '../../features/game-document/maps/map-images-window';

export const MapPopupMenu: React.FC<{
  id: string;
  menu: MenuList[];
  popupOverlay: Popup;
  onMenuSelected: (selectedMenu: MenuList) => void;
}> = ({ id, menu, popupOverlay, onMenuSelected }) => {
  const popupRef = React.useRef<HTMLDivElement | null>(null);

  const handleClickOutside = React.useCallback(
    (e: MouseEvent) => {
      const popup = popupRef.current;
      if (popup && !popup.contains(e.target as Node)) popupOverlay.hide();
    },
    [popupOverlay]
  );

  React.useEffect(() => {
    if (id) document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [id, handleClickOutside]);

  return (
    <>
      <div
        className={'py-3 d-flex flex-column bg-white'}
        style={{
          borderRadius: '8px'
        }}
        ref={popupRef}
        onMouseDown={(e) => e.stopPropagation()}>
        {menu.map((mn, index) => {
          return (
            <div
              className={'px-3 my-2 d-flex align-items-center'}
              role={'button'}
              key={index}
              onClick={() => onMenuSelected(mn)}>
              <span className={`material-symbols-outlined ${mn.textClass}`}>
                {mn.classIcon}
              </span>
              <span className={'mx-3'}>{mn.textMenu}</span>
            </div>
          );
        })}
      </div>
    </>
  );
};
